import "./NavConfig.css";
import React from "react";
import { Nav, NavItem } from "reactstrap";
import Logo from "./Logo";
import classnames from "classnames";
import css from "./NavConfig.module.css"
import { useStore } from "store";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";
import NavSelectionLabel from "./NavSelectionLabel";

function NavConfig({ data }) {
	const { i18n } = useTranslation()
	const t = useStore(state => state.translations)
	const rotation = useStore(state => state.rotation)
	const size = useStore(state => state.size)
	const theme = useStore(state => state.theme)
	const table = useStore(state => state.table)
	const ring = useStore(state => state.ring)
	const control = useStore(state => state.control)

	return (
		<div className={classnames(css.selectionNav, "text-center")}>
			<Nav className={classnames(css.navBar, "ml-0")}>
				{size === "size_180cm_x_55cm" && (
					<NavItem className={classnames(css.navItem, css.navItemFirst)}>
						<p className={classnames(css.label, "mb-0")}>{t.navigation.rotation[i18n.language]}</p>
						<p className={css.selectedSettingText}>
							<NavSelectionLabel data={data.rotations && data.rotations[rotation]} setting="rotation" />
						</p>
					</NavItem>
				)}
				<NavItem className={css.navItem}>
					<p className={classnames(css.label, "mb-0")}>{t.navigation.size[i18n.language]}</p>
					<p className={css.selectedSettingText}>
						<NavSelectionLabel data={data.sizes && data.sizes[size]} setting="size" />
					</p>
				</NavItem>
				<NavItem className={css.navItem}>
					<p className={classnames(css.label, "mb-0")}>{t.navigation.theme[i18n.language]}</p>
					<p className={css.selectedSettingText}>
						<NavSelectionLabel data={data.themes && data.themes[theme] && data.themes[theme]} setting="theme" />
					</p>
				</NavItem>
				<NavItem className={css.navItem}>
					<p className={classnames(css.label, "mb-0")}>{t.navigation.table[i18n.language]}</p>
					<p className={css.selectedSettingText}>
						<NavSelectionLabel data={data.tables && data.tables[table] && data.tables[table]} setting="table" />
					</p>
				</NavItem>
				{rotation !== "pole" && (
					<NavItem className={css.navItem}>
						<p className={classnames(css.label, "mb-0")}>{t.navigation.ring[i18n.language]}</p>
						<p className={css.selectedSettingText}>
						<NavSelectionLabel data={data.rings && data.rings[ring] && data.rings[ring]} setting="ring" />
					</p>
					</NavItem>
				)}
				<NavItem className={classnames(css.navItem, css.navItemLast)}>
					<p className={classnames(css.label, "mb-0")}>{t.navigation.addons[i18n.language]}</p>
					<p className={css.selectedSettingText}>
						<NavSelectionLabel data={data.addons && data.addons.control && data.addons.control[control]} setting="control" />
					</p>
				</NavItem>
				<LanguageSwitcher />
				<Logo />
			</Nav>
		</div>
	);
}

export default NavConfig;
